import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Persisted view-mode preference for the Onboarding list (CLAUDE.md §2.3),
 * mirroring the CRM/Employees list stores. Search/kind/status filters live in
 * URL-bound page state and stay out of the store — those are server-driven
 * query params, not durable user prefs.
 */
export type OnboardingViewMode = 'table' | 'list' | 'cards' | 'grouped';

export const ONBOARDING_VIEW_MODES: OnboardingViewMode[] = [
  'table',
  'list',
  'cards',
  'grouped',
];

interface OnboardingUiState {
  view: OnboardingViewMode;
  setView: (view: OnboardingViewMode) => void;
  /** Current DRF `OrderingFilter` value (e.g. `-started_on`). Session-only. */
  ordering: string | undefined;
  setOrdering: (ordering: string | undefined) => void;
}

export const useOnboardingUi = create<OnboardingUiState>()(
  persist(
    (set) => ({
      view: 'table',
      setView: (view) => set({ view }),
      ordering: undefined,
      setOrdering: (ordering) => set({ ordering }),
    }),
    {
      name: 'hrm.onboarding:ui',
      // Only the view mode is durable — ordering stays ephemeral so refreshes
      // return to a clean default.
      partialize: (state) => ({ view: state.view }),
    },
  ),
);
